import ApiService from './api.service'

class AgentError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const AgentService = {
    /**
     * Fetch agent types 
     * 
     * @returns array of types, 
     * @throws AgentError 
    **/
    fetchTypes: async function() {
        try {
            const response = await ApiService.get('/agents/types')
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Find user by username. 
     * 
     * @returns Agent
     * @throws AgentError 
    **/
    initiateSubAgentProcess: async function(userName) {
        try {
            const response = await ApiService.get(`agents/init-subagent-process/${userName}`)
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Add subagent to list. 
     * 
     * @returns ResponseStatus
     * @throws AgentError 
    **/
    addSubagent: async function(agentID, data) {
        try {
            const response = await ApiService.post(`agents/${agentID}/subagents`, data)
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Pull all subagents belonging to the agent with agentID. 
     * 
     * @returns ResponseStatus
     * @throws AgentError 
    **/
    pullSubagents: async function(agentID) {
        try {
            const response = await ApiService.get(`agents/${agentID}/subagents`)
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Transfer units from agent account to self main account 
     * 
     * @returns ResponseStatus
     * @throws AgentError 
    **/
    selfTransfer: async function(data) {
        try {
            const response = await ApiService.post('agents/self-transfer', data)
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Add subagent to list. 
     * 
     * @returns ResponseStatus
     * @throws AgentError 
    **/
    saleUnits: async function(data) {
        try {
            const response = await ApiService.post('agents/sale-units', data)
            
            return response.data
        } catch (error) {
            throw new AgentError(error.response.status, error.response.data.detail)
        }
    },
}

export { AgentService, AgentError }
